import { apiService, createRequestHeadersConfig } from 'shared/api'
import { capitalizeWords } from 'shared/utils/common'

import { PostalCodeResponseTypes } from './types'

const api = apiService()

export const getDeliveryMethodsByAddressService = async (
  postalCode: string,
  city: string,
  token?: string
) => {
  const url = `/deliveries?postal_code=${postalCode?.trim().toLowerCase()}&town=${capitalizeWords(city?.trim())}`

  const result: PostalCodeResponseTypes = await api.get(
    url,
    createRequestHeadersConfig(token)
  )

  return result?.data?.data
}

interface GetCitiesByPostalCodeResponse {
  data: string[]
}

export const getCitiesByPostalCodeService = async (postalCode: string) => {
  const url = `/deliveries/towns?postal_code=${postalCode}`

  const result = await api.get<GetCitiesByPostalCodeResponse>(url)

  return result.data.data
}

interface ReportMissingDeliveryAreaPayload {
  customerFirstName: string
  customerLastName: string
  customerEmail: string
  postalCode: string
  town: string
}

export const reportMissingDeliveryArea = (
  payload: ReportMissingDeliveryAreaPayload
) => api.post(`/deliveries/unsupported-postal-code`, payload)
